import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  ProviderToken,
  Type,
} from '@angular/core';
import { Store } from '@softline/core';
import { Modal } from '@softline/ui-core';
import { BehaviorSubject } from 'rxjs';
import {
  SOFTLINE_CONFIG_EDIT_CONTEXT_COMPONENT,
  SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT,
} from '../../../utilities.shared';
import { PatchContextStore } from '../../patch-context.store';
import { PatchContextService } from '../../services/patch-context.service';

import { SeparatorComponent, TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-edit-context-dialog',
  templateUrl: './edit-context-dialog.component.html',
  styleUrls: ['./edit-context-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, SeparatorComponent, TranslatePipe],
})
export class EditContextDialogComponent implements Modal<any>, OnInit {
  private close!: (result: any) => void;
  loading$ = new BehaviorSubject<boolean>(false);

  private readonly store = inject(Store);
  private readonly patchContextService = inject(PatchContextService);
  readonly components =
    inject(
      SOFTLINE_CONFIG_EDIT_CONTEXT_COMPONENT as unknown as ProviderToken<
        Type<Component>[]
      >,
      { optional: true }
    ) ?? undefined;

  async ngOnInit(): Promise<void> {
    await this.store.dispatch(
      SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT,
      PatchContextStore.actions.load
    );
  }

  registerCloseHandler(handler: (result: any) => void): void {
    this.close = handler;
  }

  async onSave(): Promise<void> {
    const isEqual = await this.patchContextService.updateContext();
    this.close(isEqual ? isEqual : undefined);
  }
}
